export default __webpack_public_path__ + "static/media/badgeT.819ee900.jpg";